'use strict';

(function () {
	angular.module('natiwi.product-specification-filter', ['natiwi.core.cdn']);
})();